import type { GetConversationAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetConversationAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetConversationAuditByIdArgs = {
  id: string;
};

export const useGetConversationAuditById = createQueryHook<
  UseGetConversationAuditByIdArgs,
  GetConversationAuditByIdQuery['conversation_audit'],
  GetConversationAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getConversationAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({ conversation_audit: data }),
  graphqlDocument: GetConversationAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
